export const API_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:5025/api';
export const SUMSUB_API_URL = process.env.REACT_APP_SUMSUB_API_URL;
export const NOTIFICATIONS_API_URL =
  process.env.REACT_APP_NOTIFICATIONS_API_URL;
export const UPLOADS_URL =
  process.env.REACT_APP_UPLOADS_URL || 'http://localhost:5025/';
export const SOCKET_SERVER =
  process.env.REACT_APP_SOCKET_URL || 'https://api.wire24.co';
export const JWT_SECRET =  process.env.REACT_APP_JWT_SECRET || '123456';
export const REACT_APP_STATUS = process.env.REACT_APP_STATUS || 'offline';
export const REACT_APP_STATUS_COLOR =
  process.env.REACT_APP_STATUS_COLOR || 'red';
export const REACT_APP_GOOGLE_MAPS_API =
  process.env.REACT_APP_GOOGLE_MAPS_API || '123456';
export const API_KEY = process.env.REACT_APP_API_KEY;
export const USER_SECRET = process.env.REACT_APP_USER_SECRET;
export const INTERCOM_SERVICE_URL =
  process.env.REACT_APP_INTERCOM_URL || 'http://localhost:5004';
